import React, { useEffect, useState } from "react";
import StaffLayout from "@/components/StaffLayout";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError, BACKEND_URL, API_BASE } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Download } from "lucide-react";

export default function AdminFacturacion() {
  const { user } = useAuth();
  const superadmin = user?.roles?.includes("superadmin_dcc");
  const [invoices, setInvoices] = useState([]);
  const [form, setForm] = useState({ partner_slug: "banco-alfa", period_start: "2025-01-01", period_end: "2026-12-31" });
  const [gen, setGen] = useState(false);

  const load = () => api.get("/admin/invoices").then((r) => setInvoices(r.data));
  useEffect(() => { load(); }, []);

  const generate = async (e) => {
    e.preventDefault(); setGen(true);
    try {
      await api.post("/admin/invoices/generate", form);
      toast.success("Factura generada");
      load();
    } catch (er) { toast.error(formatApiError(er.response?.data?.detail)); }
    finally { setGen(false); }
  };

  const downloadPdf = async (id) => {
    const r = await api.get(`/admin/invoices/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement("a"); a.href = url; a.download = `factura-${id}.pdf`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <StaffLayout user={user} superadmin={superadmin}>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Facturación</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Facturas internas</h1>
        <p className="mt-1 text-xs text-amber-300">⚠️ Documentos internos. NO son CFDI válidos — requieren integración con Facturama u otro PAC.</p>

        <form onSubmit={generate} className="mt-6 p-4 bg-[#111827] border border-gray-800 rounded-xl grid md:grid-cols-4 gap-3">
          <select value={form.partner_slug} onChange={(e) => setForm({ ...form, partner_slug: e.target.value })}
            className="bg-[#0B0F14] border border-gray-800 rounded-md px-3 py-2 text-sm text-white">
            <option value="banco-alfa">banco-alfa</option>
            <option value="demo-bank">demo-bank</option>
          </select>
          <input type="date" value={form.period_start.slice(0,10)} onChange={(e) => setForm({ ...form, period_start: e.target.value })}
            className="bg-[#0B0F14] border border-gray-800 rounded-md px-3 py-2 text-sm text-white" />
          <input type="date" value={form.period_end.slice(0,10)} onChange={(e) => setForm({ ...form, period_end: e.target.value })}
            className="bg-[#0B0F14] border border-gray-800 rounded-md px-3 py-2 text-sm text-white" />
          <button type="submit" disabled={gen} data-testid="invoice-generate"
            className="inline-flex items-center justify-center gap-1 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white font-semibold disabled:opacity-60">
            <Plus className="w-4 h-4" /> Generar
          </button>
        </form>

        <div className="mt-6 overflow-x-auto border border-gray-800 rounded-xl">
          <table className="w-full text-sm">
            <thead className="bg-[#0F172A] text-xs uppercase tracking-widest text-gray-400">
              <tr>
                <th className="text-left px-3 py-2">Partner</th>
                <th className="text-left px-3 py-2">Periodo</th>
                <th className="text-right px-3 py-2">Licencias</th>
                <th className="text-right px-3 py-2">Tier</th>
                <th className="text-right px-3 py-2">Total (MXN)</th>
                <th className="text-right px-3 py-2">Acción</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((i) => (
                <tr key={i.id} className="border-t border-gray-800">
                  <td className="px-3 py-2 text-white">{i.partner_name}</td>
                  <td className="px-3 py-2 text-gray-400 font-mono text-xs">{i.period_start.slice(0,10)} → {i.period_end.slice(0,10)}</td>
                  <td className="px-3 py-2 text-right text-white">{i.licenses_count}</td>
                  <td className="px-3 py-2 text-right text-white">T{i.tier}</td>
                  <td className="px-3 py-2 text-right font-mono text-white">${i.total.toLocaleString("es-MX")}</td>
                  <td className="px-3 py-2 text-right">
                    <button onClick={() => downloadPdf(i.id)} className="text-xs text-[#93C5FD] hover:text-white inline-flex items-center gap-1">
                      <Download className="w-3 h-3" /> PDF
                    </button>
                  </td>
                </tr>
              ))}
              {invoices.length === 0 && <tr><td colSpan={6} className="px-3 py-8 text-center text-gray-500">Sin facturas.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </StaffLayout>
  );
}
